import { useEffect } from 'react';
import { supabase } from '../services/supabaseClient';
import Swal from 'sweetalert2';

export function useMatchRealtime(selectedCompetition, allAthletes, onMatchUpdate, onCompetitionUpdate) {
  useEffect(() => {
    if (!selectedCompetition?.id || allAthletes.length === 0) return;

    const channel = supabase
      .channel(`realtime-${selectedCompetition.id}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'matches',
          filter: `competition_id=eq.${selectedCompetition.id}`
        },
        (payload) => {
          onMatchUpdate(payload);

          if (payload.new.winner_id && payload.new.winner_id !== payload.old.winner_id) {
            const winner = allAthletes.find(a => String(a.id) === String(payload.new.winner_id));
            const nomBrut = winner?.nom || winner?.name || "Athlète";
            const prenomBrut = winner?.prenom || winner?.firstname || "";
            const winnerName = `${nomBrut.toUpperCase()} ${prenomBrut}`.trim();
            const ringNumber = payload.new.ring_id || "?";

            Swal.fire({
              title: 'Nouveau Résultat !',
              text: `${winnerName} gagne l'assaut n°${payload.new.match_ref} sur le Ring ${ringNumber}`,
              icon: 'info',
              toast: true,
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'competitions',
          filter: `id=eq.${selectedCompetition.id}`
        },
        (payload) => {
          // Synchronise is_started (et tout autre champ) sur tous les appareils connectés
          if (onCompetitionUpdate) onCompetitionUpdate(payload.new);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [selectedCompetition?.id, allAthletes, onMatchUpdate, onCompetitionUpdate]);
}